import { render, staticRenderFns } from "./Approver.vue?vue&type=template&id=68788d84"
import script from "./Approver.vue?vue&type=script&lang=js"
export * from "./Approver.vue?vue&type=script&lang=js"
import style0 from "./Approver.vue?vue&type=style&index=0&id=68788d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports